<template>
  <div style="margin:20px 0;height:100%">
    <a-table 
      :columns="columns"
      :dataSource="dataSource"
      :pagination="false"
      :row-key="record => record.id"
      bordered
      :scroll="{ x:400, y: 'calc(100vh - 300px)' }"
    >
      <span slot="customTitle"><a-icon @click="fixedCol"  type="pushpin" :theme="filled ? 'filled' : 'outlined'" /> 名称</span>
      <div style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;" slot="name" slot-scope="text">
        {{text}}
      </div>
    </a-table>
  </div>
</template>

<script>
import { nhfMixins } from '../../untils'
export default {
  props:['result'],
  mixins:[nhfMixins],
  data(){
    return {
      columns:[
        {
          dataIndex:'name',
          width: 160,
          fixed: 'left',
          scopedSlots: {customRender: 'name'},
          // title:"名称",
          slots: { title: 'customTitle' },
        },
        {
          dataIndex:'code',
          width: 90,
          title:"代码",
          align:'center'
        },
      ],
      dataSource:[],
      filled:true
    }
  },
  mounted(){
    this.initTableData()
  },
  methods:{
    changeColumns2(){
      // let rawColumnsValue = [...this.rawColumnsValue]
      if(this.filled){
        this.columns[0].fixed = 'left'
      }else{
        delete this.columns[0].fixed
      }
      // this.setState({rawColumnsValue})
    },
    fixedCol(e){
      this.filled = !this.filled
      this.changeColumns2()
      e = e || window.event;  
      if(e.stopPropagation) { //W3C阻止冒泡方法  
          e.stopPropagation();  
      } else {  
          e.cancelBubble = true; //IE阻止冒泡方法  
      }
    },
    initTableData(){
      let columns = [...this.columns]
      const {ladderList,nutritionResList} = this.result
      if(this.result && nutritionResList && ladderList){
        ladderList.forEach(item => {
          columns.push( {
            dataIndex:item,
            title:item,
            width:100,
            align:'center',
          })
        })
        this.columns = columns
        let dataSource = []
        nutritionResList.forEach((i,id) => {
          i.forEach((item,index) => {
              const val = {[ladderList[id]]:item.percentage}
              const condition = i=>i.name === item.name
              if(dataSource.some(condition)){
                const idx = dataSource.findIndex(condition)
                dataSource.splice(idx,1,{...dataSource.filter(condition)[0],...val})
              } else {
                dataSource.push({
                  ...item,
                  id:`${id}${index}`,
                  ...val
                })
              }
          })
        })
        // console.log('dataSource',dataSource)
        let arr = this.result.nutritionResList[0]
        dataSource.forEach( item =>{
          arr.forEach((i,id) =>{
            if(item.name === i.name) {
              arr[id] = {...item, ...i,id: item.id}
            }
          })
        }, [])
        this.dataSource = arr
      }
    }
  },
}
</script>
